import { Component } from "@angular/core";
import { AbstractButtonComponent } from "./abstract-button.component";

@Component({
    selector: 'outlined-button',
    template: `
    <button mat-stroked-button (click)="buttonClick.emit()" [disabled]="disabled" [ngClass]="cssClass" [class.btn-critical]="critical" [disableRipple]="true">
        <span [custom-label]="label"></span>
    </button>`,
    styles: [require('./button.component.css'), require('./outlined-button.component.css')]
})
export class OutlinedButtonComponent extends AbstractButtonComponent { }